<h2 [sxc-toolbar]="toolbarHelperSvc.toolbarMain(categoryInfo().EntityId)">Software</h2>

@if (items()!.length > 0) {
  <span [innerHTML]="categoryInfo()!.NotesBefore"></span>

  @for (group of groupItemsBySpecific(items()); track group.isSpecific) {
    <p>
      @if (group.isSpecific) {
        Specific Software Implementations
      } @else {
        Software packages
      }
    </p>
    <table class="table table-hover">
      <tbody>
        @for (item of group.downloads; track item.Id) {
          <tr>
            <td [sxc-toolbar]="toolbarHelperSvc.toolbarEditDownload(item.Id, item.Title, item.EntityGuid)">
              <a [href]="item.DownloadUrl" [attr.target]="item.Target">
                {{ item.Title }}
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
  <span [innerHTML]="categoryInfo()!.NotesAfter"></span>
}

@if (items().length === 0) {
  <p>No Downloads</p>
}
